import React from 'react';
import { Descriptions, Grid, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;
const { Paragraph } = Typography;

const PatientSummary = ({ patient }) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();

  // Determine current column count based on breakpoints
  let columns = 1;
  if (screens.xl || screens.lg) columns = 4;
  else if (screens.md || screens.sm) columns = 2;

  return (
    <>
      <Descriptions
        size="small"
        column={{ xs: 1, sm: 2, md: 2, lg: 4, xl: 4 }}
        contentStyle={{ wordBreak: 'break-word' }}
      >
        <Descriptions.Item label={t('patient_form.fields.gender')}>
          {patient.getGender()}
        </Descriptions.Item>
        <Descriptions.Item label={t('patient_form.fields.dob_short')}>
          {patient.getDOB()}
        </Descriptions.Item>
        <Descriptions.Item label={t('patient_form.fields.location')}>
          {patient.getLocation()}
        </Descriptions.Item>
        <Descriptions.Item label={t('patient_form.fields.id')}>
          {patient.getExternalId()}
        </Descriptions.Item>
        <Descriptions.Item label={t('patient_form.fields.mobile_number')}>
          {patient.getMobileNumber()}
        </Descriptions.Item>
        <Descriptions.Item label={t('patient_form.fields.email')}>
          {patient.getEmail()}
        </Descriptions.Item>
        <Descriptions.Item label={t('patient_form.fields.link_short')}>
          {patient.getLinkElement()}
        </Descriptions.Item>
        {!patient.getComments() && (
          <Descriptions.Item label={t('patient_form.fields.comments')} />
        )}
      </Descriptions>
      {patient.getComments() && (
        <Descriptions
          size="small"
          column={1}
          contentStyle={{ wordBreak: 'break-word' }}
        >
          <Descriptions.Item label={t('patient_form.fields.comments')}>
            <Paragraph style={{ marginBottom: 0, whiteSpace: 'pre-line' }}>
              {patient.getComments()}
            </Paragraph>
          </Descriptions.Item>
        </Descriptions>
      )}
    </>
  );
};

export default PatientSummary;